import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const DataIntelligenceMLDataAnalyticsWorkshop2025 = () => {
    const workshopImages = [
        "Workshop1.JPG ",
        "workshop2.JPG ",
        "workshop3.JPG ",
        "workshop4.JPG ",
        "workshop5.JPG",
    ];


    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        Workshop on Data Intelligence/Machine Learning & Data Analytics
                                    </h2>
                                    <div className='py-2'>
                                        <p>

                                            On the 18th September to 20 September 2025, the Department of Computer Science and Engineering (Artificial Intelligence & Machine Learning), Sridevi Women’s Engineering College, organized this event in collaboration with NEXTERAUNITECH.
                                        </p>

                                        <p>
                                            The primary objective of this workshop was to bridge the gap between classroom learning and real-world applications. While traditional lectures introduce students to theoretical foundations, workshops of this nature ensure that students can apply these concepts hands-on, thereby strengthening their understanding. To achieve this, the workshop was carefully designed with 80% hands-on training and 20% theory, ensuring that participants not only learn but also practice and implement key skills.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Data-Intelligence-ML-Data-Analytics-Workshop-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Data-Intelligence-ML-Data-Analytics-Workshop-2025/${img}`}
                                                            alt={`Data-Intelligence-ML-Data-Analytics-Workshop-2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default DataIntelligenceMLDataAnalyticsWorkshop2025;
